import { tv } from 'tailwind-variants';

export const toasty = tv({
  base: 'flex px-4 py-2 rounded-md text-left items-center gap-md font-poppins text-sm text-mono-color-darkest overflow-hidden border-hairline',
  variants: {
    variant: {
      info: 'bg-mono-100',
      warning: 'bg-feedback-color-warning-lightest',
      error: 'bg-feedback-color-error-lightest',
      success: 'bg-feedback-color-success-lightest',
    },
  },
});

export const toastIcon = tv({
  base: 'h-6',
  variants: {
    variant: {
      info: 'fill-none',
      warning: 'fill-feedback-color-warning-pure',
      error: 'fill-feedback-color-error-pure',
      success: 'fill-feedback-color-success-pure',
    },
  },
});
